import { Button, Modal } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import { AssetDetailsWallet, AssetInsight } from "../../../@types/Wallet";
import useIcons from "../../../hooks/useIcons";
import { parseAssetTypeInt } from "../../../utils";
import Swal from "sweetalert2";
import useWallet from "../../../hooks/useWallet";
import { projectPrimaryColor } from "../../../generalConfigs";
import { useEffect, useState } from "react";

type Props = {
  show: boolean;
  onClickClose: CallableFunction;
  callOnEnd: CallableFunction;
  assetsInsights: AssetInsight[];
};
export default function RemoveAssetModal({
  show,
  assetsInsights,
  onClickClose,
  callOnEnd,
}: Props) {
  const { getURI } = useIcons();
  const { removeAssetByEncodedId } = useWallet();
  const [assetsToShow, setAssetsToShow] = useState<AssetDetailsWallet[]>([]);
  const [updateOnClose, setUpdateOnClose] = useState<boolean>(false);

  useEffect(() => {
    setAssetsToShow(
      assetsInsights.map((assetInsight) => assetInsight.asset_details)
    );
    setUpdateOnClose(false);
  }, [show]);

  function removeAssetFromShow(encodedId: string) {
    setAssetsToShow((assets) =>
      assets.filter((asset) => asset.encoded_id != encodedId)
    );
  }

  function handleOnClickClose() {
    if (updateOnClose) {
      return callOnEnd();
    }

    return onClickClose();
  }

  async function handleRemoveAsset(
    name: string,
    symbol: string,
    encodedId: string
  ) {
    Swal.fire({
      title: `Remover ${symbol} da sua carteira?`,
      text: `Tem certeza de que deseja remover ${name} (${symbol}) da sua carteira?`,
      icon: "question",
      showCancelButton: true,
      confirmButtonColor: "var(--danger)",
      cancelButtonColor: "gray",
      confirmButtonText: "Remover",
      cancelButtonText: "Cancelar",
      background: "var(--bg-1)",
      color: "var(--text-1)",
    }).then(async (result) => {
      if (result.isConfirmed) {
        Swal.fire({
          title: "Removendo...",
          html: '<div style="overflow: hidden"><div class="spinner-border"></div></div>',
          background: "var(--bg-1)",
          color: "var(--text-1)",
          showConfirmButton: false,
          allowOutsideClick: false,
          allowEscapeKey: false,
        });

        const status = await removeAssetByEncodedId(encodedId);

        if (status === 200) {
          removeAssetFromShow(encodedId);
          setUpdateOnClose(true);

          Swal.fire({
            title: "Sucesso!",
            text: `${name} (${symbol}) foi removido da sua carteira.`,
            icon: "success",
            confirmButtonColor: projectPrimaryColor,
            background: "var(--bg-1)",
            color: "var(--text-1)",
          });
        } else {
          Swal.fire({
            title: "Ops!",
            text: "Infelizmente, aconteceu um erro desconhecido, por favor, tente novamente.",
            icon: "error",
            confirmButtonColor: projectPrimaryColor,
            background: "var(--bg-1)",
            color: "var(--text-1)",
          });
        }
      }
    });
  }

  return (
    <Modal show={show} onHide={() => handleOnClickClose()}>
      <Modal.Header>
        <Modal.Title>Remover ativos</Modal.Title>
        <AiOutlineClose
          onClick={() => handleOnClickClose()}
          size={23}
          className="float-right cursor-pointer"
        />
      </Modal.Header>

      <Modal.Body>
        <span className="az-notification-title">
          Selecione o ativo que deseja remover da carteira.
        </span>
        <div className="az-notification-list mg-t-20">
          {assetsToShow.map((asset) => {
            return (
              <div
                className="media media-remove-asset"
                onClick={() =>
                  handleRemoveAsset(asset.name, asset.symbol, asset.encoded_id)
                }
              >
                <img
                  className="img-xs rounded-circle"
                  src={getURI(asset.icon)}
                />
                <div className="media-body">
                  <div className="d-flex">
                    <div>
                      <div>
                        <a>
                          <strong className="tx-primary"> {asset.name}</strong>{" "}
                        </a>
                      </div>
                      <span className="tx-12">
                        Ticker:{" "}
                        <strong className="tx-warning">{asset.symbol}</strong>
                      </span>
                      <span>
                        {parseAssetTypeInt(asset.type)} ({asset.exchange})
                      </span>
                    </div>
                    <Button
                      className="cursor-pointer mg-l-auto rounded-button"
                      variant="danger"
                      style={{ height: "20px" }}
                      size="sm"
                      onClick={() =>
                        handleRemoveAsset(
                          asset.name,
                          asset.symbol,
                          asset.encoded_id
                        )
                      }
                    >
                      Remover
                    </Button>
                  </div>
                </div>
              </div>
            );
          })}
        </div>
      </Modal.Body>
    </Modal>
  );
}
